import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from '../../../service/http.service';
import { GlobalService } from '../../../service/global.service';
import { WindowRefService } from '../../../service/window-ref.service';
import { CommonModule } from '@angular/common';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { apiConstants } from '../../../constans/constants.module';

@Component({
  selector: 'app-product-order-payment',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule],
  templateUrl: './product-order-payment.component.html',
  styleUrl: './product-order-payment.component.css'
})
export class ProductOrderPaymentComponent implements OnInit, AfterViewInit {

  @Output()
  close = new EventEmitter<boolean>();

  @Output() paymentSuccess = new EventEmitter<boolean>();


  status: any;
  pujaData: any;
  userId: any;
  palmId: any;

  /** Wallet balance available to put towards this order. */
  walletBalance: number = 0;
  /** False until the balance call answers, so we don't flash the wrong CTA. */
  balanceLoaded: boolean = false;
  /** Blocks the CTA while an order/payment round trip is in flight. */
  isProcessing: boolean = false;

  constructor(private _homeService: HttpService,
    private toastr: ToastrService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private winRef: WindowRefService,
    public gS: GlobalService) {

    // fall back to storage in case gS.userData isn't hydrated yet
    this.userId = this.gS.userData?.id ?? this.gS.getUserDataFromStorage()?.id;
    console.log(this.userId);

    this.palmId = localStorage.getItem("puja-order-form-id");
    console.log(this.palmId);

    this.pujaData = localStorage.getItem("ap-astro-puja-detail");
    this.pujaData = JSON.parse(this.pujaData);

  }

  ngOnInit(): void {
    this.getWalletBalance();
  }

  ngAfterViewInit() {
    console.log(this.pujaData, 'astroDAta');
  }

  /* ----------------------------------------------------------
     Amounts
     ---------------------------------------------------------- */

  get orderPrice(): number {
    return Number(this.pujaData?.productPrice) || 0;
  }

  /** Part of the price the wallet can cover. */
  get walletApplied(): number {
    return Math.min(this.walletBalance, this.orderPrice);
  }

  /** What's still owed after the wallet is applied. */
  get shortfall(): number {
    return this.round(Math.max(0, this.orderPrice - this.walletBalance));
  }

  /** True when the wallet can't cover the order and the card has to be charged. */
  get needsTopUp(): boolean {
    return this.shortfall > 0;
  }

  /** GST on the top-up only, matching the wallet recharge page (India only). */
  get topUpGst(): number {
    if (!this.gS.indiaZone) {
      return 0;
    }
    return this.round(this.shortfall * apiConstants.WalletGstPercent / 100);
  }

  /** Amount actually charged to the card. */
  get payableNow(): number {
    return this.round(this.shortfall + this.topUpGst);
  }

  private round(value: number): number {
    return Math.round(value * 100) / 100;
  }

  getWalletBalance() {
    // gS.customerId defaults to 0 rather than null, so fall through on falsy.
    this._homeService.getUserWalletAmount(this.gS.customerId || this.userId, 0).subscribe((data: any) => {
      this.walletBalance = Number(data?.availableBalance) || 0;
      this.balanceLoaded = true;
    }, (error) => {
      // Treat an unreadable balance as zero so the user can still pay by card
      // rather than getting stuck on a dead popup.
      this.walletBalance = 0;
      this.balanceLoaded = true;
      console.log(error);
    });
  }

  /* ----------------------------------------------------------
     Pay
     ---------------------------------------------------------- */

  /** Single CTA: pays from the wallet when it's enough, otherwise opens Razorpay. */
  payNow() {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    if (this.needsTopUp) {
      this.startTopUpPayment();
    } else {
      this.confirmPalmOrder();
    }
  }

  /** Charges the shortfall through Razorpay, then places the order. */
  startTopUpPayment() {
    let obj = {
      userId: this.userId,
      amount: this.shortfall,
      gst: this.topUpGst,
      timeZone: localStorage.getItem("timeZone"),
      couponId: 0,
      discount: 0,
    };

    this._homeService.startPaymentInitate(obj).subscribe((data: any) => {
      if (data?.status == "fail") {
        this.isProcessing = false;
        this.toastr.error("Something went wrong, please try again", "Opps !!!");
      } else {
        this.payWithRazor(data?.data?.paymentId);
      }
    }, (error) => {
      this.isProcessing = false;
      this.toastr.error("Please try again", "Something went wrong");
      console.log(error);
    });
  }

  payWithRazor(paymentIniateId: any) {
    const options: any = {
      key: apiConstants.RazorpayKey,
      amount: Math.round(this.payableNow * 100), // paise
      currency: this.gS.currencyType,
      name: 'LegalStack',
      description: this.pujaData?.productName || '',
      modal: {
        escape: false,
      },
      notes: {
        "userId": this.userId,
        "astro_order_id": paymentIniateId
      },
      theme: {
        color: '#48A6A7'
      }
    };
    options.handler = ((response: any, error: any) => {
      options.response = response;
      this.paymentCapture(response, paymentIniateId);
    });
    options.modal.ondismiss = (() => {
      // Keep the popup open so they can retry — cancelling a payment
      // shouldn't throw away the order they just filled in.
      this.isProcessing = false;
      this.toastr.error("Please try again", "Transaction cancelled.");
      console.log('Transaction cancelled.');
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }

  /** Confirms the top-up with the backend, then places the order. */
  paymentCapture(gatewayid: any, transactionId: any) {
    let obj = {
      txID: transactionId,
      paymentGatewayTxID: gatewayid.razorpay_payment_id
    };

    this._homeService.completePayment(obj).subscribe((data: any) => {
      if (data?.status == "fail") {
        this.isProcessing = false;
        this.toastr.error("Something went wrong, please try again", "Ops");
      } else {
        // Money is in the wallet now — cover the order with it.
        this.walletBalance = this.walletBalance + this.shortfall;
        this.confirmPalmOrder();
      }
    }, (error) => {
      this.isProcessing = false;
      this.toastr.error("Payment received but the order could not be placed. Please contact support.", "Ops");
      console.log(error);
    });
  }

  confirmPalmOrder() {

    let data = {
      userId: this.userId,
      orderId: localStorage.getItem("puja-order-form-id"),
      productId: this.pujaData.id,
      productPrice: this.pujaData?.productPrice,
      zoneType: localStorage.getItem("timeZone")
    }
    this._homeService.confirmPujaOrder(data).subscribe((data) => {
      this.status = data;
      this.status = this.status;
      if (this.status.status == "success") {
        this.isProcessing = false;
        this.toastr.success("Congratulations ! Your order placed successfully!", "Success");

        this.paymentSuccess.emit(true);
      } else {
        this.isProcessing = false;
        this.toastr.error(this.status.reason, "Ops!!");
      }
    }, (error) => {
      this.isProcessing = false;
      this.toastr.error("Something went wrong, please try again", "Failed to login");
      console.log(error);
    });
  }

  handleOffcanvasClose() {
    if (this.isProcessing) {
      return;
    }
    this.close.emit(true);
  }

}
